import { render } from "./SuccessProjects.vue?vue&type=template&id=96d7ed74"
import script from "./SuccessProjects.vue?vue&type=script&lang=js"
export * from "./SuccessProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__